<template>
  <form class="gift-card__balance form">
    <div class="gift-card__balance-title">Проверить баланс подарочной карты</div>
    <div class="gift-card__balance-cont">
      <div class="gift-card__balance-text">Чтобы узнать остаток на вашей подарочной карте, введите номер карты</div>
      <div class="gift-card__balance-inputs">
        <div class="form_row" :class="{ 'error': $v.cardNumber.$error }">
          <input type="text" v-model.number="cardNumber" class="form_row" placeholder="Номер карты">
        </div>
        <div class="form_row" :class="{ 'error': $v.cardCVC.$error }">
          <input type="text" v-model.number="cardCVC" class="form_row" placeholder="CVC код">
        </div>
        <input type="submit" @click.prevent="getBalance" @keydown.enter="getBalance" value="Узнать" class="btn btn_red">
      </div>
      <div class="gift-card__balance-info"><a href="#" @click.prevent="openFaq">Как найти номер и CVC-код?</a></div>
    </div>
    <gift-popup v-if="modal.show" :message="modal.message"></gift-popup>
  </form>
</template>
<script>
import {required, minLength} from 'vuelidate/lib/validators'
export default {
  name: "BalanceForm",
  data()
  {
    return {
      cardNumber: null,
      cardCVC: null,
      modal: {
        show: false,
        message: "",
      }
    }
  },
  validations: {
    cardNumber: {
      required,
    },
    cardCVC: {
      required,
      minLength: minLength(3),
    },
  },
  methods:{
    openFaq()
    {
      this.modal.show = true;
      this.modal.message = 'А никак';
    },
    getBalance()
    {
      let formData = new FormData;
      formData.append('cvc', this.cardCVC);
      this.$v.$touch();
      if (this.$v.$invalid)
      {
        return;
      }

      fetch(`/api/gift-cards/${this.cardNumber}/balance/`, {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then( json => {
        if(json.data && json.data.balance)
        {
          this.modal.message = `Остаток на карте: ${json.data.balance} руб.`;
        }
        else
        {
          this.modal.message = json.message;
        }
        this.modal.show = true;
        this.cardNumber = null;
        this.cardCVC = null;
        this.$v.$reset;
      })
    }
  },

}
</script>
